var map = {
	"./cloud1.png": "3145",
	"./cloud2.png": "fd2a",
	"./cloud3.png": "62da",
	"./cloud4.png": "9425",
	"./cloud5.png": "20cd",
	"./cloud6.png": "3a8e",
	"./cloud7.png": "ef63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "54e9";